function equalizeFeatureCardHeights() {
  const cards = document.querySelectorAll('.js-equal-height');
  if (!cards.length) return;

  cards.forEach(card => card.style.minHeight = 'auto');

  let rows = {};

  cards.forEach(card => {
    const top = Math.round(card.getBoundingClientRect().top);
    rows[top] = rows[top] || [];
    rows[top].push(card);
  });

  Object.values(rows).forEach(row => {
    const max = Math.max(...row.map(card => card.offsetHeight));
    row.forEach(card => card.style.minHeight = `${max}px`);
  });
}

function initSliderButtons(sliderEl) {
  const slider = sliderEl.querySelector('.slider');
  const slides = slider?.querySelectorAll('.slider__slide');
  const prevBtn = sliderEl.querySelector('.slider-button--prev');
  const nextBtn = sliderEl.querySelector('.slider-button--next');

  if (!slider || !slides.length) return;

  const getGap = () => parseInt(getComputedStyle(slider).getPropertyValue('--card-gap')) || 16;

  function scrollPrev() {
    const slideWidth = slides[0].offsetWidth;
    slider.scrollBy({
      left: -(slideWidth + getGap()),
      behavior: 'smooth'
    });
  }

  function scrollNext() {
    const slideWidth = slides[0].offsetWidth;
    slider.scrollBy({
      left: slideWidth + getGap(),
      behavior: 'smooth'
    });
  }

  function updateButtons() {
    const scrollLeft = slider.scrollLeft;
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    if (prevBtn) prevBtn.disabled = scrollLeft <= 1;
    if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 1;
  }

  if (prevBtn) prevBtn.addEventListener('click', scrollPrev);
  if (nextBtn) nextBtn.addEventListener('click', scrollNext);
  slider.addEventListener('scroll', updateButtons);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      equalizeFeatureCardHeights();
      updateButtons();
    }, 200);
  });

  // Init
  updateButtons();
}

document.addEventListener('DOMContentLoaded', () => {
  equalizeFeatureCardHeights();
  document.querySelectorAll('slider-component').forEach(initSliderButtons);
});
